var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-autocomplete", {
        attrs: {
          items: _vm.values,
          "item-text": "name",
          "item-value": "uid",
          label: _vm.title,
          chips: "",
          "small-chips": "",
          "deletable-chips": "",
          multiple: "",
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }